import { DefaultTheme } from '@egalite/theme/default';

export type Variant = 'xs' | 'small' | 'medium' | 'large' | 'xxl';

const makeBtnSize = (variant: Variant, breakpoints: DefaultTheme['breakpoints'], options?: { square: boolean; noRadius: boolean }) => {
	if (variant == null) return ``;

	let values;
	if (variant === 'xs') {
		values = {
			height: '3.5rem',
			fontSize: '1.4rem',
			minWidth: '291px',
			padding: '1.2rem 3rem',
			borderRadius: '5rem',
		};
	} else if (variant === 'small') {
		values = {
			height: '4.4rem',
			fontSize: '1.6rem',
			minWidth: '291px',
			padding: '1.2rem 3rem',
			borderRadius: '5rem',
		};
	} else if (variant === 'medium') {
		values = {
			height: '5rem',
			fontSize: '1.8rem',
			minWidth: '291px',
			padding: '1.3rem 2rem',
			borderRadius: '5rem',
		};
	} else if (variant === 'large') {
		values = {
			height: '5.5rem',
			fontSize: '1.8rem',
			minWidth: '291px',
			padding: '1.5rem 4rem',
			borderRadius: '5rem',
			smallPadding: '1.5rem 2rem',
		};
	} else if (variant === 'xxl') {
		values = {
			height: '9.5rem',
			fontSize: '2.6rem',
			padding: '2rem',
			borderRadius: '5rem',
		};
	} else {
		values = {
			height: '7.5rem',
			fontSize: '2.6rem',
			maxWidth: '448px',
			padding: '2rem 6rem',
			borderRadius: '5rem',
			smallPadding: '2rem 3rem',
		};
	}

	return `
			height: ${values.height};
			font-size: ${values.fontSize};
			min-width: ${options?.square ? 'auto' : values.minWidth};
			max-width: ${values.maxWidth};
			padding: ${options?.square ? '0' : values.padding};
			border-radius: ${options?.noRadius ? '1rem' : values.borderRadius};
	
			width: ${options?.square ? values.height : ''};
			transition: color .3s, background-color .3s, border-color .5s;
	
			${[breakpoints.down('md')]} {
				padding: ${values.smallPadding};
			}
		`;
};

export default makeBtnSize;
